import { ConfigOption } from '@ngx-formly/core';
import { BankListDropdownComponent } from './components/bank-list-dropdown/bank-list-dropdown.component';
import { FormlyBankAccountLinkListComponent } from './components/formly-bank-account-link-list/formly-bank-account-link-list.component';
import { FormlyTenantBankAccountLinkListComponent } from './components/formly-tenant-bank-account-link-list/formly-tenant-bank-account-link-list.component';
import { BankAccountDropdownComponent } from './controls/bank-account-dropdown/bank-account-dropdown.component';

export const BANKING_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-bank-list-dropdown', component: BankListDropdownComponent, wrappers: ['simple-title'] },
  { name: 'formly-bank-account-dropdown', component: BankAccountDropdownComponent, wrappers: ['simple-title'] },
  { name: 'formly-bank-account-link-list', component: FormlyBankAccountLinkListComponent, wrappers: ['simple-title'] },
  { name: 'formly-tenant-bank-account-link-list', component: FormlyTenantBankAccountLinkListComponent, wrappers: ['simple-title'] },
]
